import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { deviceService } from '../servicesHardware/deviceService';
import { AlertService } from './alert.service'
import { OidcService } from './oidc.service';
import { RoutingStateService } from './routing-state.service';


@Injectable({
  providedIn: 'root'
})
export class GuardsService implements CanActivate {

  constructor(private router: Router, private deviceServices : deviceService, private alertService: AlertService, private oidc: OidcService, private routingService : RoutingStateService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    
    if(route.url != null && route.url[0] != null && route.url[0].path != null)
    {
      let fullPath = "/"+route.url[0].path
      if(route.queryParamMap != null && route.queryParamMap.keys != null && route.queryParamMap.keys.length > 0 )
      {
        fullPath += "?"
        for(let i=0 ; i < route.queryParamMap.keys.length ; i++ )
        {
          fullPath += route.queryParamMap.keys[i]+"="+route.queryParamMap.get(route.queryParamMap.keys[i])
          if(i != route.queryParamMap.keys.length-1)
            fullPath += "&"
        }
      }
      this.routingService.addElem(fullPath)
    }
    let userInfo = this.deviceServices.decryptDataLocalStorage('userSession')
    if(userInfo != null)
    {
      // let userInfo = JSON.parse(resp)
      if (userInfo != null && userInfo.currentUser != null && (userInfo.tokenTimeLimit > Date.now() - 20000)) {
        return true;
      }
      else if(this.oidc != null && 
        this.oidc.access_token_expiration !=null && 
        this.oidc.refreshTokenExist &&
        ((Date.now() - 1000) > this.oidc.access_token_expiration))
      {
        //TODO
        //try to do an automatique reconnexion using refresh token (eventualy check "stay connexted box")                
      }
      //todo else if tokenTimeLimit has expired && if refreshTokenExist
    }

    // not logged in : redirection to login page
    this.alertService.error({"subType": "401","message": ""})
    
    // this.router.navigate(['/login'], { queryParams: { returnUrl: state.url }});      
    return false;
  }
}